import { createApp } from 'vue';
import VueCookies from 'vue-cookies';

import App from './App.vue';
import router from './router';
import store from './store/store';
import {
	currency,
	currencyAlt,
	date,
	day,
	monthAndYear,
	time,
} from './filters';
import VueClickAway from 'vue3-click-away';
// import './filters';
// import './directives';

import VInput from '@/components/VInput';
import VSelect from '@/components/VSelect';
import VSelect2 from '@/components/VSelect2';
import VCheckbox from '@/components/VCheckbox';
import VDatepicker from '@/components/VDatepicker';
import axios from 'axios';
// import '../public/gtm'

const app = createApp(App);

app.config.productionTip = false;
app.config.performance = true;
app.config.globalProperties.$checkIfSoonExpiration = function () {
	let now = new Date();
	let expirationDate = new Date(sessionStorage.getItem('expirationDate'));
	if (expirationDate) {
		let diffInMinutes = Math.abs((now - expirationDate) / (1000 * 60));

		if (diffInMinutes < window.MOVIE_CHECK_TIME) {
			store.dispatch('newLogoutTime');
			return true;
		} else {
			return false;
		}
	}
};

/* eslint-disable-next-line */
axios.defaults.baseURL = CONFIG_API_URL;

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Access-Control-Allow-Methods'] =
	'GET,PUT,POST,DELETE,OPTIONS';
axios.defaults.headers.common['Access-Control-Allow-Headers'] =
	'Content-Type, Origin, X-Requested-With, Content-Type, Accept';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

app.use(VueCookies);
app.use(VueClickAway);

app.component('v-input', VInput);
app.component('v-select', VSelect);
app.component('v-select-2', VSelect2);
app.component('v-checkbox', VCheckbox);
app.component('v-datepicker', VDatepicker);

VueCookies.config('7d');

axios.interceptors.response.use(
	(response) => {
		return response;
	},
	function (error) {
		if (error.response.status == 401) {
			store.dispatch('logOut');
		}
		return Promise.reject(error.response);
	}
);

app.config.globalProperties.$filters = {
	currency,
	currencyAlt,
	date,
	day,
	monthAndYear,
	time,
};

app.use(router).use(store).mount('#MyFx');
